<template>
  <div class="app-page scroll">
    <div class="main">
      <h1>Pricing</h1>

         <div class="text-center top-msg">
            <h2>All plans include 3D Perception, Physical AI, and EdgeFirst Fusion workflows.</h2>
          </div>
    
       <div class="row justify-content-center padding-bot-20">
            <TabsSelector
              v-model="planTerm"
              :items="planTerms"
            />
          </div>

      <div class="signup">
        <PricingSection 
        :planTerm="planTerm"
         @plan_clicked="planClickedHandler"
        />
      </div>
    </div>
  </div>
</template>

<script setup>
import PricingSection from '@/components/subscription/PricingSection.vue';
import TabsSelector from '@/components/TabsSelector.vue';
import { useRouter } from 'vue-router';
import {ref} from 'vue';
const router = useRouter();

const  planTerms =ref([
  { value: 'short', display: "Monthly" },
  { value: 'year', display: "Save by choosing annual plan" },
]);
const planTerm = ref("year");

function planClickedHandler(v) {
  if  (v.name.includes("custom")) 
  {
     router.push({ path: '/contact' });
    return;
  }

  router.push({ path: '/signup' });
}

</script>

<style lang="scss" scoped>
.main {
  margin: 30px;
  background: white;
  padding-top: 20px;
  padding-bottom: 20px;
  border-radius: 10px;
  height: fit-content;
  width: fit-content;
}
.app-page {
  align-items: center;
  text-align: center;
  overflow: visible;
  height: 100dvh;
  background-color: #250e81 !important;
  background-image: url("@/assets/img/blu-stripes.png") !important;
}

.signup {
  display: flex;
  flex-direction: column;
  flex: 1 1 100%;
  height: 100%;
  padding: 16px 100px;
  align-items: center;
  // justify-content: center;
  overflow: auto;
}

@media (max-width: $breakpoint-sm) {
  .signup {
    padding: 8px;
  }
}
@media (max-width: $breakpoint-md) {
  .signup {
    padding: 16px;
  }
}

.top-msg {
  margin: 20px;
}

.scroll {
  overflow-y: scroll;
}

</style>
